<template>
  <nav
    class="navbar navbar-expand-lg navbar-dark ftco_navbar bg-dark ftco-navbar-light"
    id="ftco-navbar"
  >
    <div class="container custom-container mx-lg-0 mx-lg-auto">
      <a class="navbar-brand d-flex justify-content-start" href="#">
        <router-link to="/">
          <img 
            src="@/assets/site/images/logo-new.png"
            class="logo-fluid mt-2 "
            width="100%" 
            alt
          />
        </router-link>
      </a>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#ftco-nav"
        aria-controls="ftco-nav"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="oi oi-menu"></span> Menu
      </button>
      <div class="collapse navbar-collapse" id="ftco-nav">
        <!-- <ul class="list-unstyled mb-0">
          <li class="pb-0"> -->
            <ul class="navbar-nav">
              <li class="nav-item dropdown">
                <a
                  class="nav-link dropdown-item no-active"
                  aria-haspopup="true"
                  aria-expanded="false"
                  data-target=".navbar-collapse.show"
                >
                  Shop Mother & Baby Care
                </a>
                <ul
                  class="dropdown-menu"
                  aria-labelledby="navbarDropdownMenuLink"
                >
                  <li>
                    <a
                      href="/shop#!/Breast-Pumps/c/153505064"
                      class="dropdown-item no-active"
                      data-target=".navbar-collapse.show"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      Breast Pumps
                    </a>
                  </li>
                 
                  <li>
                    <a
                      href="/shop#!/Breast-Pump-Accessories/c/153505102"
                      class="dropdown-item no-active"
                      data-target=".navbar-collapse.show"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      Breast Pump Accessories
                    </a>
                  </li>
                  <li>
                    <a
                      href="/shop#!/Lactation-and-Feeding/c/153506564"
                      class="dropdown-item no-active"
                      data-target=".navbar-collapse.show"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      Lactation and Feeding
                    </a>
                  </li>
                  <li>
                    <a
                      href="/shop#!/Maternity/c/153505101"
                      class="dropdown-item no-active"
                      data-target=".navbar-collapse.show"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                    Maternity & Post Partum
                    </a>
                  </li>
                  <li>
                  
                    <a
                      href="/shop#!/Simple-Body/c/153506812"
                      class="dropdown-item no-active"
                      data-target=".navbar-collapse.show"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                    Mama & Baby Skin Care
                    </a>
                  </li>

                  <li>
                    <a
                      href="/shop#!/Accessories/c/153506817"
                      class="dropdown-item no-active"
                      data-target=".navbar-collapse.show"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      Other Accessories
                    </a>
                  </li>
                  <li>
                    <router-link
                      data-toggle="collapse"
                      aria-haspopup="true"
                      aria-expanded="false"
                      data-target=".navbar-collapse.show"
                      to="/compare-breast-pumps"
                      class="dropdown-item no-active"
                    >
                      Compare Breast Pumps
                    </router-link>
                  </li>
                  <li>
                    <router-link
                      data-toggle="collapse"
                      aria-haspopup="true"
                      aria-expanded="false"
                      data-target=".navbar-collapse.show"
                      to="/choose"
                      class="dropdown-item no-active"
                    >
                    Choose Breast Pump Tool 
                    </router-link>
                  </li>
                </ul>
              </li>

              <li class="nav-item dropdown">
                <a
                  class="nav-link dropdown-item no-active"
                  aria-haspopup="true"
                  aria-expanded="false"
                  data-target=".navbar-collapse.show"
                >
                  CPAP / BIPAP
                </a>
                <ul
                  class="dropdown-menu"
                  aria-labelledby="navbarDropdownMenuLink"
                >
                  <li>
                    <a
                      href="/shop#!/CPAP-BIPAP/c/153505095"
                      class="dropdown-item no-active"
                      data-target=".navbar-collapse.show"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      CPAP / BIPAP
                    </a>
                  </li>
                  <li>
                    <a
                      href="/shop#!/Masks/c/153507809"
                      class="dropdown-item no-active"
                      data-target=".navbar-collapse.show"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      Masks
                    </a>
                  </li>
                  <li>
                    <router-link
                      data-toggle="collapse"
                      aria-haspopup="true"
                      aria-expanded="false"
                      data-target=".navbar-collapse.show"
                      to="/resmed-masks"
                      class="dropdown-item no-active"
                    >
                    Resmed Products</router-link
                    >
                  </li>
                  <li>
                    <a
                      href="/shop#!/Replacement-Parts-Cushions/c/153508797"
                      class="dropdown-item no-active"
                      data-target=".navbar-collapse.show"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      Replacement Parts
                    </a>
                  </li>
                  <li>
                    <a
                      href="/shop#!/Supplies/c/153508796"
                      class="dropdown-item no-active"
                      data-target=".navbar-collapse.show"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      Supplies
                    </a>
                  </li>
                </ul>
              </li>

              <li class="nav-item dropdown">
                <a
                  class="nav-link dropdown-item no-active"
                  aria-haspopup="true"
                  aria-expanded="false"
                  data-target=".navbar-collapse.show"
                >
                  Durable Medical Equipment
                </a>
                <ul
                  class="dropdown-menu"
                  aria-labelledby="navbarDropdownMenuLink"
                >
                  <li>
                    <a
                      href="/shop#!/Durable-Medical-Equipment/c/153506326"
                      class="dropdown-item no-active"
                      data-target=".navbar-collapse.show"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      Durable Medical Equipment
                    </a>
                  </li>
                  <li>
                    <a
                      href="/shop#!/Mobility/c/154248300"
                      class="dropdown-item no-active"
                      data-target=".navbar-collapse.show"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      Mobility
                    </a>
                  </li>
                  <li>
                    <a
                      href="/shop#!/Bathroom-Aids/c/154248060"
                      class="dropdown-item no-active"
                      data-target=".navbar-collapse.show"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      Bathroom Aids
                    </a>
                  </li>
                  <li>
                    <a
                      href="/shop#!/Accessories/c/154248057"
                      class="dropdown-item no-active"
                      data-target=".navbar-collapse.show"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      Accessories
                    </a>
                  </li>
                </ul>
              </li>   
              <li class="nav-item">
                <a
                  href="/shop#!/Compression/c/153505103"
                  class="nav-link"
                  aria-haspopup="true"
                  aria-expanded="false"
                  data-target=".navbar-collapse.show"
                >
                  Compression</a
                >
              </li>
              <li class="nav-item dropdown">
                <router-link
                  to=""
                  class="nav-link dropdown-item no-active"
                  aria-haspopup="true"
                  aria-expanded="false"
                  data-target=".navbar-collapse.show"
                  >Lactation Resources
                </router-link>
                <ul
                  class="dropdown-menu"
                  aria-labelledby="navbarDropdownMenuLink"
                >
                  <!-- <li>
                    <router-link
                      data-toggle="collapse"
                      aria-haspopup="true"
                      aria-expanded="false"
                      data-target=".navbar-collapse.show"
                      to="/site"
                      class="dropdown-item no-active"
                    >
                      Education Class Login
                    </router-link>
                  </li> -->
                  <li>
                    <router-link
                      data-toggle="collapse"
                      aria-haspopup="true"
                      aria-expanded="false"
                      data-target=".navbar-collapse.show"
                      to="/lactation_edn"
                      class="dropdown-item no-active"
                    >
                      Lactation Education
                    </router-link>
                  </li>
                  <li>
                    <router-link
                      data-toggle="collapse"
                      aria-haspopup="true"
                      aria-expanded="false"
                      data-target=".navbar-collapse.show"
                      to="/lactation_res"
                      class="dropdown-item no-active"
                    >
                      Lactation Resources
                    </router-link>
                  </li>

                  <li>
                    <router-link
                      data-toggle="collapse"
                      aria-haspopup="true"
                      aria-expanded="false"
                      data-target=".navbar-collapse.show"
                      to="/lactation_res/best_start"
                      class="dropdown-item no-active"
                    >
                      Successful Breastfeeding
                    </router-link>
                  </li>
                  <li>
                    <router-link
                      data-toggle="collapse"
                      aria-haspopup="true"
                      aria-expanded="false"
                      data-target=".navbar-collapse.show"
                      to="/lactation_res/classes"
                      class="dropdown-item no-active"
                    >
                      Classes, Support Groups
                    </router-link>
                  </li>
                  <li>
                    <a
                      href="/pdf/breast-pump-cdc cleaning.pdf"
                      target="_blank"
                      class="dropdown-item no-active"
                      rel="nofollow"
                      >Breast pump cleaning (PDF)
                    </a>
                  </li>
                  <li>
                    <a
                      href="/pdf/Best_Practices_for_Milk_Storage.pdf"
                      target="_blank"
                      rel="nofollow"
                      class="dropdown-item no-active"
                      >Milk Storage (PDF)</a
                    >
                  </li>
                  <li>
                    <router-link
                      data-toggle="collapse"
                      aria-haspopup="true"
                      aria-expanded="false"
                      data-target=".navbar-collapse.show"
                      to="/lactation_res/flange_size"
                      class="dropdown-item no-active"
                    >
                    Flange Size Guide</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      data-toggle="collapse"
                      aria-haspopup="true"
                      aria-expanded="false"
                      data-target=".navbar-collapse.show"
                      to="/lactation_res/national"
                      class="dropdown-item no-active"
                    >
                      Breastfeeding Resources</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      data-toggle="collapse"
                      aria-haspopup="true"
                      aria-expanded="false"
                      data-target=".navbar-collapse.show"
                      to="/lactation_res/pumping"
                      class="dropdown-item no-active"
                    >
                      Pumping Tips</router-link
                    >
                  </li>
                </ul>
              </li>
              <li class="nav-item">
                <router-link
                  to="/prescriptions"
                  class="nav-link"
                  data-toggle="collapse"
                  data-target=".navbar-collapse.show"
                >
                  Prescriptions</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  to="/contact"
                  class="nav-link"
                  data-toggle="collapse"
                  data-target=".navbar-collapse.show"
                >
                  Contact</router-link
                >
              </li>
             

              <li class="nav-item">
                <a href="/shop#!/~/account" class="nav-link"> Login</a>
              </li>
            
              <li class="nav-item" id="cartIcon">
                <div
                  data-layout="SMALL_ICON_COUNTER"
                  class="ec-cart-widget"
                  data-target=".navbar-collapse.show"
                  aria-haspopup="true"
                  aria-expanded="false"
                ></div>
              </li>

              <li
                class="nav-item dropdown"
                v-if="userData && userData.user.role == 'User'"
              >
                <router-link
                  to="/user"
                  class="nav-link"
                  id="navbarDropdownMenuLink"
                  data-toggle="collapse"
                  aria-haspopup="true"
                  aria-expanded="false"
                  data-target=".navbar-collapse.show"
                  >My Account</router-link
                >
                <ul
                  class="dropdown-menu"
                  aria-labelledby="navbarDropdownMenuLink"
                >
                  <li>
                    <router-link
                      data-toggle="collapse"
                      aria-haspopup="true"
                      aria-expanded="false"
                      data-target=".navbar-collapse.show"
                      to="/user/dashboard"
                      class="dropdown-item no-active"
                    >
                      My Dashboard
                    </router-link>
                  </li>
                  <li>
                    <router-link
                      data-toggle="collapse"
                      aria-haspopup="true"
                      aria-expanded="false"
                      data-target=".navbar-collapse.show"
                      to="/user/reset_password"
                      class="dropdown-item no-active"
                    >
                      Reset Password
                    </router-link>
                  </li>
                  <li>
                    <router-link
                      data-toggle="collapse"
                      aria-haspopup="true"
                      aria-expanded="false"
                      data-target=".navbar-collapse.show"
                      to="/user/joned_meetings"
                      class="dropdown-item no-active"
                      >Online Classes</router-link
                    >
                  </li>
                  <li>
                    <a class="dropdown-item" href="#" @click="logout">Logout</a>
                  </li>
                </ul>
              </li>
            </ul>
          <!-- </li>
        </ul> -->
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "HomeBar",
  data() {
    return {
      homeview: true,
      userData: [],
      oc_login_link: null,
    };
  },
  created() {
    this.setUserDatas();
  },
  methods: {
    setUserDatas() {
      var loc_UserData = localStorage.getItem("userData");
      this.userData = JSON.parse(loc_UserData);
      var oc_login_anthor_link = localStorage.getItem("oc_login_link");
      this.oc_login_link = JSON.parse(oc_login_anthor_link);
    },
    logout() {
      localStorage.clear();
      window.location.href = "/";
    },

    opencartlogin() {
      var oc_login_link = localStorage.getItem("oc_login_link");
      var oc_login_anthor_link = JSON.parse(oc_login_link);
      localStorage.setItem("oc_login_link", JSON.stringify(null));
      if (oc_login_anthor_link === null) {
        window.location.href = "https://cart.calmedhawaii.com";
      } else {
        window.location.href = oc_login_anthor_link;
      }
    },
  },
  mounted() {
    const ecwidScript = document.createElement("script");
    ecwidScript.src =
      "https://app.ecwid.com/script.js?89844749&data_platform=code&data_date=2023-09-28";
    ecwidScript.charset = "utf-8";
    ecwidScript.dataset.cfasync = "false";
    document.head.appendChild(ecwidScript);
    ecwidScript.onload = () => {
      if (window.Ecwid) {
        window.Ecwid.init();
      }
    };
  },
};
</script>

<style>
.router-link-active {
  color: var(--primary) !important;
  color: #045C68;
  border-bottom: 3px solid var(--primary);
  border-bottom: 3px solid #045C68;
  display: inline-block;
}

.logo-fluid{
  padding: 1%;
}

.dropdown {
  cursor: pointer;
}

.no-active {
  color: var(--dark) !important;
  border-bottom: none !important;
  display: inline-block;
}

#cartIcon {
  display: flex !important;
  align-items: center !important;
}

.dropdown-toggle::after {
  display: none;
}
</style>
